import Vue from 'vue'
import Vuex from 'vuex'
import { authentication } from './modules/authentication'
import { units } from './modules/units'
import { operators } from './modules/operators'
import { news } from './modules/news'
import { questions } from './modules/questions'
import { widgets } from './modules/widget-setting'
import { common } from './modules/common'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authentication,
    units,
    operators,
    news,
    questions,
    common,
    widgets,
  }
})
